module.exports = __webpack_public_path__ + "img/icon_eye_open@2x.e6011dc2.png";